import Select from "react-select";
import Button from "../../../components/Button.jsx";
import {IntegrationActions, IntegrationSection, OAuthConnectionStatus} from "./IntegrationDetailUi.jsx";
import {useTranslation} from "react-i18next";

export default function OAuthAdAccountsFormLayout({
                                                      providerName,
                                                      reconnectRequired,
                                                      connectButton,
                                                      accountSelectName,
                                                      selectedAccounts,
                                                      accountOptions,
                                                      onAccountsChange,
                                                      onRefresh,
                                                      onSave,
                                                  }) {
    const {t} = useTranslation();
    return <div className={'flex flex-col gap-5'}>
        <IntegrationSection
            title={`Připojení k ${providerName}`}
            description={'OAuth připojení slouží k bezpečnému načtení dostupných reklamních účtů. Obnovení připojení nezmění uložený výběr.'}
        >
            <OAuthConnectionStatus connected={!reconnectRequired} action={connectButton}/>
        </IntegrationSection>

        <IntegrationSection
            title={'Reklamní účty'}
            description={'Vyberte účty, které má Datixo pravidelně stahovat a zahrnout do reportingu.'}
        >
            <Select
                value={selectedAccounts}
                isMulti
                name={accountSelectName}
                options={accountOptions}
                className={'basic-multi-select'}
                classNamePrefix={'select'}
                placeholder={null}
                noOptionsMessage={() => t('project.integration-no-options')}
                onChange={onAccountsChange}
            />
            <div className={'mt-5'}>
                <IntegrationActions hint={<Button variant={'outline-primary'} className={'integration-secondary-button'} onClick={onRefresh}>Aktualizovat seznam</Button>}>
                    <Button className={'button-primary'} onClick={onSave}>Uložit výběr</Button>
                </IntegrationActions>
            </div>
        </IntegrationSection>
    </div>;
}
